import { render } from "./TheHeader.vue?vue&type=template&id=2be6aabe&scoped=true"
import script from "./TheHeader.vue?vue&type=script&lang=js"
export * from "./TheHeader.vue?vue&type=script&lang=js"

import "./TheHeader.vue?vue&type=style&index=0&id=2be6aabe&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2be6aabe"

export default script